import { uniqueFeatureProperties } from "@cartographerio/geometry";
import { Feature } from "geojson";
import {
  Bucket,
  bucketLabel,
  findMatchingBucket,
  findMatchingBuckets,
  multiBucketLabel,
  PropertyType,
  PropertyValue,
  valueLabel,
} from "../bucket";
import { Attribute, TypedAttribute } from "./type";

export function isAutoAttribute(attr: Attribute): boolean {
  switch (attr.type) {
    case "SimpleAttribute":
      return false;
    case "PropertyAttribute":
      switch (attr.buckets.type) {
        case "AutoBuckets":
          return true;
        case "StandardBuckets":
          return false;
      }
  }
}

export function attributePropertyName(attr: Attribute): string | null {
  switch (attr.type) {
    case "SimpleAttribute":
      return null;
    case "PropertyAttribute":
      return attr.propertyName;
  }
}

export function attributePropertyType(attr: Attribute): PropertyType | null {
  switch (attr.type) {
    case "SimpleAttribute":
      return null;
    case "PropertyAttribute":
      return attr.propertyType;
  }
}

export function attributeUnit(attr: Attribute): string | null {
  switch (attr.type) {
    case "SimpleAttribute":
      return null;
    case "PropertyAttribute":
      return attr.unit ?? null;
  }
}

export function attributeValueLabel<
  A extends PropertyType,
  B extends PropertyValue
>(attr: TypedAttribute<A, B>, buckets: Bucket<B>[], value: B): string {
  const bucket = findMatchingBucket(buckets, value);
  const label = bucket && bucketLabel(bucket, attr.propertyType);
  return label ?? valueLabel(value, attr.propertyType);
}

export function attributeFeaturesLabel(
  attr: Attribute,
  buckets: Bucket[],
  features: Feature[]
): string | null {
  switch (attr.type) {
    case "SimpleAttribute":
      return null;

    case "PropertyAttribute": {
      const matching = findMatchingBuckets(
        buckets,
        uniqueFeatureProperties(features, attr.propertyName) as PropertyValue[]
      );

      return multiBucketLabel(matching, attr.propertyType);
    }
  }
}
